document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const link = target?.closest('[data-bk-line-cta]');

  if (!link) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'bk_line_cta_click',
    cta_position: link.dataset.bkLineCta,
    offer: link.dataset.bkLineOffer,
    page_path: window.location.pathname,
  });
});
